import React, { Component } from 'react';
import { formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  BaseCrud,
  FormSection,
  FormSectionColumn
} from 'react/containers/layout/Crud';
import {
  LookupField,
  CheckboxField,
  RadioGroupField,
  SelectField,
  TextField,
  GroupField
} from 'react/components/fields';

const sendingAppliedRuleStopOptions = [
  {
    label:
      'DocumentSendingConfiguration.field.sendingAppliedRule.departFromStop',
    value: 'DEPART_FROM_STOP'
  }
];

const sendingAppliedRuleRouteOptions = [
  {
    label:
      'DocumentSendingConfiguration.field.sendingAppliedRule.completeRoute',
    value: 'COMPLETE_ROUTE'
  },
  {
    label: 'DocumentSendingConfiguration.field.sendingAppliedRule.arriveAtDc',
    value: 'ARRIVED_ORIGIN'
  }
];
class DocumentSendingConfigurationCrud extends Component {
  constructor(props) {
    super(props);

    const { entity } = this.props;
    App.Forms[entity] = App.Forms[entity] || {};
    App.Objects[entity].beforeList = () => {
      const { filterBuilder } = App.Forms[entity];
      const updateGrid = (collection) => {
        const addPaginationGrid = true;
        const tableLayout = Monet.Grid.getGridLayout(
          App.Forms[entity].layout.index
        );
        const { pagination } = App.Forms[entity];

        if (pagination.first === 0) {
          Monet.Grid.addDataToGrid(
            entity,
            tableLayout,
            collection,
            addPaginationGrid
          );
        } else {
          Monet.Grid.appendDataToGridAfterPagination(
            entity,
            tableLayout,
            collection
          );
        }
      };
      filterBuilder.changeCriteriaBeforeFilter = function (criteria) {
        criteria.criteriaChain[0].and = criteria.criteriaChain[0].and.map(
          (item) => {
            if (item.attr === 'mobileDocumentType') {
              item.attr = 'mobileDocumentType.documentEntityLevel';
            }
            return item;
          }
        );

        return criteria;
      };
      filterBuilder.setCallbacks({
        success: (data) => {
          const newModels = [];
          const newData = data;
          data.models.forEach((item) => {
            const newItem = item;
            const { documentEntityLevel } = item.attributes.mobileDocumentType;
            newItem.attributes.mobileDocumentType = documentEntityLevel;
            newModels.push(newItem);
          });
          newData.models = newModels;
          updateGrid(newData);
        }
      });
    };
  }

  getMobileDocumentType = () => {
    const { mobileDocumentType } = this.props;

    if (mobileDocumentType?.documentEntityLevel) {
      return mobileDocumentType.documentEntityLevel;
    }
    return undefined;
  };

  getSendingAppliedRule = () => {
    const { mobileDocumentType, sendingMethod, sendingAppliedRule } =
      this.props;

    const routeOptions = sendingAppliedRuleRouteOptions.map(
      (option) => option.value
    );

    if (sendingMethod === 'AUTOMATIC' && mobileDocumentType === 'STOP')
      return sendingAppliedRuleStopOptions[0].value;
    if (
      sendingMethod === 'AUTOMATIC' &&
      mobileDocumentType === 'ROUTE' &&
      !routeOptions?.includes(sendingAppliedRule)
    )
      return sendingAppliedRuleRouteOptions[0].value;

    return sendingAppliedRule;
  };

  validateEmail = (value) => {
    const mailformat =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (!value) {
      return 'general.mandatoryField';
    }
    if (!mailformat.test(value)) {
      return Monet.I18n.getResourcesByKey('Event.emailInvalidFormat');
    }
    return undefined;
  };

  renderEmailAddressFields = () => {
    const {
      emailAddress,
      changeAction,
      isGrid,
      entity,
      sendingMethod,
      mobileDocumentType
    } = this.props;

    if (!isGrid && emailAddress && !emailAddress.length) {
      changeAction(entity, 'emailAddress', [{}]);
    }

    return (
      <div className="repeaterGroupField">
        <label>
          {`${Monet.I18n.getResourcesByKey(
            'DocumentSendingConfiguration.field.emailAddress'
          )}*`}
        </label>
        <GroupField name="emailAddress" requiredOnce>
          <TextField
            label="users.email"
            name="emailAddress"
            validate={
              sendingMethod === 'AUTOMATIC' && mobileDocumentType === 'ROUTE'
                ? this.validateEmail
                : undefined
            }
          />
        </GroupField>
      </div>
    );
  };

  renderRouteRelatedRecipients = () => {
    const { sendToDriver, sendToHelper } = this.props;
    return (
      <>
        <div style={{ display: 'flex', height: '24px' }}>
          <CheckboxField
            customClassName="customCheckboxField"
            label="sendDocument.routeRelatedUsersEmail"
            value={sendToDriver}
            name="sendToDriver"
          />
          <label>{Monet.I18n.getResourcesByKey('configuration.driver')}</label>
        </div>
        <div style={{ display: 'flex' }}>
          <CheckboxField
            customClassName="customCheckboxField"
            value={sendToHelper}
            name="sendToHelper"
            label=""
          />
          <label>{Monet.I18n.getResourcesByKey('driver.HELPER')}</label>
        </div>
      </>
    );
  };

  shouldToShowLocationTypeFieldBy = (mobileDocumentType) => {
    const isStop =
      this.getMobileDocumentType() === 'STOP' || mobileDocumentType === 'STOP';
    const isOrder =
      this.getMobileDocumentType() === 'ORDER' ||
      mobileDocumentType === 'ORDER';
    return isStop || isOrder;
  };

  renderGeneralSection = () => {
    const { mobileDocumentType } = this.props;

    return (
      <FormSection title="DocumentSendingConfiguration.section.general">
        <FormSectionColumn>
          <LookupField
            label="DocumentType.field.organization"
            name="organization"
            lookupEntity="Organization"
            lookupEntityColumn="description"
            disabledOnEdit
            required
          />
          <RadioGroupField
            name="mobileDocumentType"
            disabledOnEdit
            label="DocumentSendingConfiguration.field.mobileDocumentType"
            defaultValue="STOP"
            options={[
              {
                label:
                  'DocumentSendingConfiguration.field.mobileDocumentType.order',
                value: 'ORDER',
                optionHint:
                  'DocumentSendingConfiguration.field.mobileDocumentType.order.hint'
              },
              {
                label:
                  'DocumentSendingConfiguration.field.mobileDocumentType.stop',
                value: 'STOP',
                optionHint:
                  'DocumentSendingConfiguration.field.mobileDocumentType.stop.hint'
              },
              {
                label:
                  'DocumentSendingConfiguration.field.mobileDocumentType.route',
                value: 'ROUTE',
                optionHint:
                  'DocumentSendingConfiguration.field.mobileDocumentType.route.hint'
              }
            ]}
            value={this.getMobileDocumentType()}
          />
          <LookupField
            label="DocumentType.field.locationType"
            name="locationTypes"
            lookupEntity="LocationType"
            lookupEntityColumn="description"
            shouldShow={this.shouldToShowLocationTypeFieldBy(
              mobileDocumentType
            )}
            required
            multiple
          />
        </FormSectionColumn>
      </FormSection>
    );
  };

  renderDocumentSubmissionRulesSession = () => {
    const { mobileDocumentType, sendingMethod, sendDocumentByEmail } =
      this.props;

    return (
      <FormSection title="DocumentSendingConfiguration.section.documentRules">
        <FormSectionColumn>
          <CheckboxField
            label="DocumentType.field.allowDriverPrintDocuments"
            name="allowDriverPrintDocument"
          />
          <CheckboxField
            label="DocumentSendingConfiguration.field.sendAndPrintAllDocuments"
            name="sendAndPrintAllDocuments"
          />
        </FormSectionColumn>
        <FormSectionColumn>
          <CheckboxField
            label="DocumentType.field.sendDocumentByEmail"
            name="sendDocumentByEmail"
          />
          <RadioGroupField
            name="sendingMethod"
            label="DocumentType.field.documentTypeSender"
            defaultValue="MANUAL"
            shouldShow={sendDocumentByEmail}
            value={sendDocumentByEmail && !sendingMethod ? 'MANUAL' : undefined}
            options={[
              {
                label: 'DocumentType.field.documentTypeSender.manual',
                value: 'MANUAL',
                optionHint:
                  'DocumentSendingConfiguration.field.sendingMethod.hintManual'
              },
              {
                label: 'DocumentType.field.documentTypeSender.automatic',
                value: 'AUTOMATIC',
                optionHint:
                  mobileDocumentType === 'STOP'
                    ? 'DocumentSendingConfiguration.field.sendingMethod.hintAutomaticStop'
                    : 'DocumentSendingConfiguration.field.sendingMethod.hintAutomatic'
              }
            ]}
          />
          {sendingMethod === 'AUTOMATIC' && mobileDocumentType === 'ROUTE' && (
            <div>{this.renderEmailAddressFields()}</div>
          )}
          {sendingMethod === 'AUTOMATIC' && (
            <div>{this.renderRouteRelatedRecipients()}</div>
          )}
          {sendingMethod === 'AUTOMATIC' && (
            <SelectField
              label="DocumentSendingConfiguration.field.sendingAppliedRule"
              name="sendingAppliedRule"
              options={
                mobileDocumentType === 'ROUTE'
                  ? sendingAppliedRuleRouteOptions
                  : sendingAppliedRuleStopOptions
              }
              value={this.getSendingAppliedRule()}
              required
            />
          )}
        </FormSectionColumn>
      </FormSection>
    );
  };

  beforeSubmit = (values) => {
    const {
      mobileDocumentType,
      organization,
      sendingMethod,
      sendDocumentByEmail,
      emailAddress
    } = values;

    const adjustedValues = values;
    if (mobileDocumentType && organization) {
      const mobileDocumentTypeAdjusted = {
        documentEntityLevel: mobileDocumentType,
        organization: {
          id: organization.id
        }
      };
      adjustedValues.mobileDocumentType = mobileDocumentTypeAdjusted;
    }

    if (!sendingMethod || sendingMethod === 'MANUAL') {
      adjustedValues.sendingAppliedRule = null;
    }
    if (!sendDocumentByEmail) {
      adjustedValues.sendingMethod = null;
    }
    adjustedValues.emailAddress =
      emailAddress?.length && sendingMethod !== 'MANUAL'
        ? emailAddress.filter((item) => Object.keys(item).length)
        : [];
    return adjustedValues;
  };

  render() {
    const customCriteria = [
      'organization.id',
      'organization.description',
      'mobileDocumentType',
      'emailAddress.*',
      'locationTypes.id',
      'locationTypes.description',
      'allowDriverPrintDocument',
      'sendAndPrintAllDocuments',
      'sendToDriver',
      'sendToHelper',
      'sendDocumentByEmail',
      'sendingMethod',
      'sendingAppliedRule'
    ];
    return (
      <BaseCrud
        tabName="documentType.gridIndex"
        customCriteria={customCriteria}
        beforeSubmit={this.beforeSubmit}
        {...this.props}
      >
        {this.renderGeneralSection()}
        {this.renderDocumentSubmissionRulesSession()}
      </BaseCrud>
    );
  }
}

DocumentSendingConfigurationCrud.propTypes = {
  mobileDocumentType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  changeAction: PropTypes.func.isRequired,
  entity: PropTypes.string.isRequired,
  sendingMethod: PropTypes.string,
  sendingAppliedRule: PropTypes.string,
  emailAddress: PropTypes.array,
  isGrid: PropTypes.bool,
  sendToDriver: PropTypes.bool,
  sendToHelper: PropTypes.bool
};

DocumentSendingConfigurationCrud.defaultProps = {
  mobileDocumentType: null,
  sendingMethod: null,
  sendingAppliedRule: null,
  emailAddress: [],
  isGrid: false,
  sendDocumentByEmail: false,
  sendToDriver: false,
  sendToHelper: false
};

const valueSelector = formValueSelector('DocumentSendingConfiguration');

const mapStateToProps = (state) => ({
  mobileDocumentType: valueSelector(state, 'mobileDocumentType'),
  sendingMethod: valueSelector(state, 'sendingMethod'),
  sendingAppliedRule: valueSelector(state, 'sendingAppliedRule'),
  emailAddress: valueSelector(state, 'emailAddress'),
  sendDocumentByEmail: valueSelector(state, 'sendDocumentByEmail'),
  sendToDriver: valueSelector(state, 'sendToDriver'),
  sendToHelper: valueSelector(state, 'sendToHelper')
});

const mapDispatchToProps = {
  changeAction: change
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentSendingConfigurationCrud);
